import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './SearchResults.css';

// Page de resultats de recherche
// Recupere les recettes depuis l'API TheMealDB
function SearchResults() {
    // Recupere les parametres de l'URL (ex: ?q=chicken)
    const [searchParams] = useSearchParams();
    const query = searchParams.get('q');

    // States pour gerer les donnees
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // useEffect pour appeler l'API quand la recherche change
    useEffect(() => {
        // Fonction pour recuperer les recettes
        const fetchRecipes = async () => {
            // Si pas de recherche, on arrete
            if (!query) {
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);

                // Appel a l'API TheMealDB
                const response = await fetch(
                    `https://www.themealdb.com/api/json/v1/1/search.php?s=${query}`
                );
                const data = await response.json();

                // data.meals est null si aucun resultat
                setRecipes(data.meals || []);
            } catch (err) {
                console.error('Erreur lors de la recherche:', err);
                setError('Une erreur est survenue lors de la recherche');
            } finally {
                setLoading(false);
            }
        };

        fetchRecipes();
    }, [query]);

    // Affichage pendant le chargement
    if (loading) {
        return (
            <div className="search-results">
                <div className="loader">Chargement...</div>
            </div>
        );
    }

    // Affichage en cas d'erreur
    if (error) {
        return (
            <div className="search-results">
                <div className="error-message">{error}</div>
            </div>
        );
    }

    return (
        <div className="search-results">
            {/* Titre avec le nombre de resultats */}
            <h2 className="results-title">
                {recipes.length > 0
                    ? `${recipes.length} resultat(s) pour "${query}"`
                    : `Aucun resultat pour "${query}"`}
            </h2>

            {/* Grille de recettes */}
            <div className="recipes-grid">
                {recipes.map((recipe) => (
                    <Link
                        key={recipe.idMeal}
                        to={`/recipe/${recipe.idMeal}`}
                        className="recipe-card"
                    >
                        {/* Image de la recette */}
                        <img
                            src={recipe.strMealThumb}
                            alt={recipe.strMeal}
                            className="recipe-image"
                        />

                        {/* Informations de la recette */}
                        <div className="recipe-info">
                            <h3 className="recipe-name">{recipe.strMeal}</h3>
                            <p className="recipe-category">{recipe.strCategory}</p>
                            <p className="recipe-area">{recipe.strArea}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default SearchResults;
